/* HealthifyRx Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky Header ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── Mobile Menu ──
  const toggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      const spans = toggle.querySelectorAll('span');
      toggle.classList.toggle('active');
      if (toggle.classList.contains('active')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  // ── FAQ Accordion ──
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (question && answer) {
      question.addEventListener('click', () => {
        const isOpen = answer.classList.contains('open');
        // Close all
        faqItems.forEach(i => {
          i.querySelector('.faq-answer')?.classList.remove('open');
          i.querySelector('.faq-question')?.classList.remove('active');
        });
        // Open clicked (if was closed)
        if (!isOpen) {
          answer.classList.add('open');
          question.classList.add('active');
        }
      });
    }
  });

  // ── Cart Count Update ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── Add to Cart (Pricing Section) ──
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const productHandle = this.getAttribute('data-product-handle');

      if (!variantId && productHandle) {
        // Redirect to product page if no variant ID
        window.location.href = '/products/' + productHandle;
        return;
      }

      if (!variantId) return;

      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          this.textContent = '✓ Added!';
          updateCartCount();
          setTimeout(() => {
            this.textContent = originalText;
            this.disabled = false;
          }, 2000);
        })
        .catch(() => {
          this.textContent = originalText;
          this.disabled = false;
          window.location.href = '/products/' + productHandle;
        });
    });
  });

  // ── Product Page Add to Cart ──
  const productForm = document.querySelector('#product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('[type="submit"]');
      const formData = new FormData(this);
      const originalText = btn.textContent;

      btn.textContent = 'Adding to cart...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Added to Cart!';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2500);
        })
        .catch(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  // ── Cart Quantity Updates ──
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const line = this.closest('[data-line]')?.getAttribute('data-line');
      const action = this.getAttribute('data-action');
      const currentQty = parseInt(this.closest('.cart-item-qty')?.querySelector('.qty-display')?.textContent || '1');
      const newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: newQty })
      })
        .then(() => location.reload())
        .catch(() => {});
    });
  });

  // ── Scroll Reveal ──
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

});
